import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding
  const permissions = store.getters.permissions || new Set()
  let hasPermission = false
  if (value) {
    if (typeof value === 'string' || value instanceof String) {
      hasPermission = permissions.has(value)
    } else if (Array.isArray(value)) {
      const { modifiers } = binding
      if (modifiers.all) {
        hasPermission = !value.some(permission => {
          return !permissions.has(permission)
        })
      } else {
        hasPermission = value.some(permission => {
          return permissions.has(permission)
        })
      }
      
    } else {
      throw new Error('permission must be String or Array')
    }
  } else {
    throw new Error(`need permission! Like v-permission="['code']"`)
  }

  if (!hasPermission) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}



// WEBPACK FOOTER //
// ./src/common/permission/permission.js